<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseInput
						name="title"
						label="Title"
						type="text"
						v-model="data.title"
						class="form-control form-control-lg dashInput"
						rules="required|min:4"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseInput
						name="placeName"
						label="Place Name"
						type="text"
						class="form-control form-control-lg dashInput"
						v-model="data.activity"
						rules="required|min:4"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.country.id ? data.country.id : ''"
					/>
				</div>

				<div class="form-group col-sm-6 mb-6">
					<BaseMultiSelect
						@change:value="getCities"
						@update:value="setCity"
						:options="multiSelectState.citiesSelect"
						rules="required"
						name="City"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.city.id ? data.city.id : ''"
					/>
				</div>
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setSight"
						:options="multiSelectState.sightOptions"
						rules="required"
						name="Sights"
						mode="multiple"
						:closeOnSelect="false"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.sightSeeingOptions"
					/>
				</div>
				<div class="form-group col-sm-3">
					<BaseMultiSelect
						@update:value="setPreference"
						:options="multiSelectState.preferences"
						rules="required"
						name="Preference"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
						:defaultData="data.preferences ? data.preferences : ''"
					/>
				</div>
				<div class="from-group col-sm-3">
					<BaseInput
						name="Travel Date"
						label="Travel Date"
						type="date"
						:min="`${new Date().getFullYear()}-${
							new Date().getMonth() + 1 < 10
								? '0' + (new Date().getMonth() + 1)
								: new Date().getMonth() + 1
						}-${new Date().getDate() + 1}`"
						v-model="data.travelDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div
					class="mt-2 form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
				>
					<input
						class="form-check-input"
						type="checkbox"
						v-model="data.meal"
						id="flexCheckIndeterminate"
						value="breakfast"
					/>
					<label
						class="form-check-label mx-1 pt-1 text-dark"
						for="flexCheckIndeterminate"
					>
						Breakfast
					</label>
				</div>
				<div
					class="form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
				>
					<input
						class="form-check-input"
						type="checkbox"
						v-model="data.meal"
						id="flexCheckIndeterminate"
						value="lunch"
					/>
					<label
						class="form-check-label mx-1 pt-1 text-dark"
						for="flexCheckIndeterminate"
					>
						Lunch
					</label>
				</div>

				<div
					class="form-group col-sm-3 mb-4 d-flex justify-content-space-between align-items-center"
				>
					<input
						class="form-check-input"
						type="checkbox"
						v-model="data.meal"
						id="flexCheckIndeterminate"
						value="dinner"
					/>
					<label
						class="form-check-label mx-1 pt-1 text-dark"
						for="flexCheckIndeterminate"
					>
						Dinner
					</label>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";
	import API from "@/config/api";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "LeadSightseeing",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Array, Object, String], default: "" },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				country: {
					id: 0,
					name: null,
				},
				city: {
					id: 0,
					name: null,
				},
				title: null,
				activity: null,
				day: props.count + 1,
				meal: [],
				sightSeeingOptions: [],
				preferences: null,
				travelDate: null,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.country.name && data.city.name) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				cities: [],
				citiesSelect: [],
				sights: [],
				sightOptions: [],
				preferences: Helper.preferences,
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
				getCities({ country: data.country.name });
			};

			// ! City Functions

			const getCities = async (cityObj) => {
				let cityData = {};
				if (cityObj?.country) {
					cityData.countryName = cityObj?.country;
				}
				if (cityObj?.name && cityObj.name.length < 3) return;
				else if (cityObj?.name && cityObj.name.length > 3)
					cityData.name = cityObj.name;

				try {
					const cities = await Helper.getCities(cityData);

					if (multiSelectState.cities instanceof Array)
						multiSelectState.cities = [...cities];
					else multiSelectState.cities = cities;

					const changeFormat = cities.map((city) => {
						return { label: city.name, value: city.id };
					});

					multiSelectState.citiesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const setCity = (dataObj) => {
				if (!dataObj) {
					data.city.id = 0;
					data.city.name = null;
					return;
				}
				const city = multiSelectState.cities.filter(
					(city) => city.id === dataObj,
				);
				data.city.id = city[0].id;
				data.city.name = city[0].name;
				getSights();
			};

			const getSights = async () => {
				let queryString = "";

				if (data.city.name) {
					queryString = `?city=${data.city.name}`;
				}
				if (data.country.name) {
					queryString = `${queryString ? `${queryString}&` : "?"}country=${
						data.country.name
					}`;
				}
				try {
					const response = await API.privateRequest.get(
						`sights${queryString || ""}`,
					);
					const sights = response.data.data;
					multiSelectState.sights = sights;
					const changeFormat = sights.map((sight) => {
						return { label: sight.activity, value: sight._id };
					});

					multiSelectState.sightOptions = [...changeFormat];
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const setSight = (payload) => {
				data.sightSeeingOptions = [...payload];
			};

			const setPreference = (payload) => {
				data.preferences = payload;
			};

			if (
				props.defaultData instanceof Array ||
				props.defaultData instanceof Object
			) {
				let keys = Object.keys(data);
				keys.map((key) => (data[key] = props.defaultData[key] || data[key]));
				data.travelDate = props.defaultData?.travelDate.split("T")[0];

				multiSelectState.cities = [
					...multiSelectState.cities,
					{
						id: props.defaultData?.city.id,
						name: props.defaultData?.city.name,
					},
				];
				multiSelectState.citiesSelect = [
					...multiSelectState.citiesSelect,
					{
						value: props.defaultData?.city.id,
						label: props.defaultData?.city.name,
					},
				];

				multiSelectState.countries = [
					...multiSelectState.countries,
					{
						id: props.defaultData?.country.id,
						name: props.defaultData?.country.name,
					},
				];
				multiSelectState.countriesSelect = [
					...multiSelectState.countriesSelect,
					{
						value: props.defaultData?.country.id,
						label: props.defaultData?.country.name,
					},
				];

				getSights();
			}

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setCountry,
				getCities,
				setCity,
				setSight,
				setPreference,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
